import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import googleAnalytics from "./plugins/google-analytics";
import L from "leaflet";

Vue.config.productionTip = false;
Vue.use(googleAnalytics, {
  GA_MEASUREMENT_ID: "G-CPZ9Y5RWST"
  // dev GA_MEASUREMENT_ID: "G-RXY0876P66",
});

// eslint-disable-next-line
delete L.Icon.Default.prototype._getIconUrl;
// eslint-disable-next-line
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
